import {
  DefaultTestSlotLocationAddress,
  SlotLocationAddress,
} from './slotLocationAddress';
import { CernerSlot, DefaultTestSlotList } from './cernerSlot';

export interface LocationGroup {
  locationId?: string;
  locationName?: string;
  slotList?: CernerSlot[];
  timeZone?: string;
  locationAddress?: SlotLocationAddress;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestLocationGroupList = new Array(2)
  .fill(undefined)
  .map((item, index) => ({
    locationId: `location${index}`,
    locationName: `Location ${index}`,
    slotList: DefaultTestSlotList,
    timeZone: 'Central Time (CT)',
    locationAddress: DefaultTestSlotLocationAddress,
  }));
